import { render, staticRenderFns } from "./ModalUserData.vue?vue&type=template&id=a748b0cc&scoped=true&lang=pug&"
import script from "./ModalUserData.vue?vue&type=script&lang=ts&"
export * from "./ModalUserData.vue?vue&type=script&lang=ts&"
import style0 from "./ModalUserData.vue?vue&type=style&index=0&id=a748b0cc&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a748b0cc",
  null
  
)

export default component.exports